import {createContext} from 'react';

export type TurnstileContextProps = {
  getToken: () => Promise<string>;
};

export const TurnstileContext = createContext<TurnstileContextProps | null>(null);
